import { Container } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import AppHeader from "@saleor/components/AppHeader";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
import { FilterPageProps, ListProps, TabPageProps } from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import { ProductStocksReport_productStocks_edges_node } from "../../types/ProductStocksReport";
import { ProductStockList } from "../ProductStockList";
import {
  createFilterStructure,
  ProductStockFilterKeys,
  ProductStockFilterOpts
} from "./filters";

export interface ProductStockPageProps
  extends ListProps,
    FilterPageProps<ProductStockFilterKeys, ProductStockFilterOpts>,
    TabPageProps {
  productStocks: ProductStocksReport_productStocks_edges_node[];
  onProductStockRowClick: (id: string, variantId: string) => () => void;
  onBack: () => void;
  download: () => void;
}

export const ProductStockPage: React.FC<ProductStockPageProps> = ({
  currentTab,
  filterOpts,
  initialSearch,
  onSearchChange,
  onFilterChange,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  onProductStockRowClick,
  tabs,
  productStocks,
  currencySymbol,
  onBack,
  download,
  ...listProps
}) => {
  const intl = useIntl();
  const structure = createFilterStructure(intl, filterOpts);
  return (
    <>
      <Container>
        <AppHeader onBack={onBack}>
          {intl.formatMessage({
            defaultMessage: "Reports",
            description: "reports"
          })}
        </AppHeader>
        <PageHeader title="Product Stocks">
          <Button
            color="primary"
            variant="contained"
            disabled={!productStocks}
            onClick={download}
          >
            Download
          </Button>
        </PageHeader>

        <Card>
          <FilterBar
            allTabLabel={intl.formatMessage({
              defaultMessage: "All",
              description: "tab name"
            })}
            currencySymbol={currencySymbol}
            currentTab={currentTab}
            tabs={tabs}
            filterStructure={structure}
            searchPlaceholder={intl.formatMessage({
              defaultMessage: "Search by Product or SKU"
            })}
            initialSearch={initialSearch}
            onSearchChange={onSearchChange}
            onFilterChange={onFilterChange}
            onAll={onAll}
            onTabChange={onTabChange}
            onTabDelete={onTabDelete}
            onTabSave={onTabSave}
          />

          <ProductStockList
            onProductStockRowClick={onProductStockRowClick}
            productStocks={productStocks}
            {...listProps}
          />
        </Card>
      </Container>
    </>
  );
};

export default ProductStockPage;
